import { reverseTranslateStatus } from "utils/translate/status"

export default function switchStatusColor(status) {
  const statusLowercase = reverseTranslateStatus(status)
  switch (statusLowercase) {
    case "pending":
      return "secondary"
    case "returned":
      return "warning"
    case "completed":
      return "success"
    case "missing":
      return "error"
    default:
      return "secondary"
  }
}

export function generateColorPerStatus(status) {
  switch (status) {
    case "A Enlever":
      return "#02c39a"
    case "Anomalie d`Enlévement":
      return "#00a896"
    case "Anomalie de Livraison":
      return "#028090"
    case "Au Dépô":
      return "#05668d"
    case "Echange Reçu":
      return "#f6ae2d"
    case "pending":
      return "#86bbd8"
    case "En Cours de Livraison":
      return "#33658a"
    case "EN COURS":
      return "#2f4858"
    case "En Depot":
      return "#64615e"
    case "Enlevé":
      return "#3e6259"
    case "Enleve":
      return "#3e6259"
    case "En Transit":
      return "#080c36"
    case "Livré":
      return "#55a630"
    case "Livré Payé":
      return "#e9c46a"
    case "NON REÇUE":
      return "#8abca7"
    case "Payé":
      return "#77bfa3"
    case "Préparation Retour":
      return "#98c9a3"
    case "Retour Payé":
      return "#505423"
    case "Retour":
      return "#233d4d"
    case "Retour Reçu":
      return "#385d8a"
    case "Retour Client Agence":
      return "#5ca4a9"
    case "Retour Définitif":
      return "#1985a1"
    case "Retour Expéditeur":
      return "#166088"
    case "Retour Dépôt":
      return "#4a6fa5"
    case "Retour Recu Magasin":
      return "#2b4162"
    case "Préparation Livraison":
      return "#5c7aa3"
    case "Dispatch":
      return "#3d5a80"
    case "Livré Provisoirement":
      return "#80b918"
    case "Prep Paiement":
      return "#a7c957"
    case "Verification":
      return "#6c757d"
    case "Echange":
      return "#e09f3e"
    case "Exception":
      return "#c1121f"
    case "Manquant":
      return "#E53935"
    case "Endommagé":
      return "#E53888"
    default:
      return "#4f6d7a"
  }
}
